import { noop } from 'lodash';
import { dataTransformationToJsonForPost } from './request';

// this is limited to only conversational AI requests
// since it is the only one that supports streaming
export const streamingRequest = async ({
  method = 'POST',
  url,
  data,
  onChunks = noop,
}) => {
  const baseURL = Pollfish.helper.getBaseRequestURL();
  const requestURL = baseURL + url;
  const body = dataTransformationToJsonForPost(data);
  const response = await fetch(requestURL, {
    method,
    body,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  if (!response.ok) {
    throw new Error('Network error.');
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let remainingChunk = '';

  while (true) {
    // eslint-disable-next-line no-await-in-loop
    const { done, value } = await reader.read();
    if (done) {
      break;
    }
    const textChunk = remainingChunk + decoder.decode(value, { stream: true });
    const {
      jsonChunks,
      remainingChunk: newRemainingChunk,
    } = convertStreamingJsonToChunks(textChunk);

    remainingChunk = newRemainingChunk;
    onChunks(jsonChunks);
  }
};

export default streamingRequest;

export function convertStreamingJsonToChunks(text) {
  const jsonChunks = text
    .split(/(?<=\})\B(?=\{)/gim) // split multiple json objects
    .map((jsonChunk, index, allChunks) => {
      try {
        const json = JSON.parse(jsonChunk);
        return json;
      } catch (e) {
        if (index === allChunks.length - 1) {
          return jsonChunk;
        }
        throw new Error('Invalid JSON chunk');
      }
    });
  // check for incomplete chunk
  const lastChunk = jsonChunks[jsonChunks.length - 1];
  let remainingChunk = '';
  if (typeof lastChunk === 'string') {
    jsonChunks.pop();
    remainingChunk = lastChunk;
  }
  return { jsonChunks, remainingChunk };
}
